import { styled } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const EmployeesListW = styled('div')`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  background: ${({ theme }) => theme.palette.white.main};
  border-radius: 8px;
  overflow: hidden;
  padding: 16px;

  @media (max-width: 1023px) {
    margin-top: 16px;
  }
`;

export const EmployeeRow = styled('div')`
  display: flex;
  align-items: center;
  column-gap: 16px;
  padding: 12px 16px;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 8px;
  cursor: pointer;
  background: ${({ theme }) => theme.palette.white.main};

  &:hover {
    background: ${({ theme }) => theme.palette.white.p100};
  }

  p {
    flex: 1;
    margin: 0;
    font-size: 16px;
    font-weight: 500;
  }

  svg {
    color: #333;
    flex-shrink: 0;
  }
`;

export const SeeMoreLink = styled(NavLink)`
  display: block;
  text-align: right;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    opacity: 0.7;
  }
`;
